import { render } from "./OrganizerShell.vue?vue&type=template&id=dfd2259a&scoped=true"
import script from "./OrganizerShell.vue?vue&type=script&lang=js"
export * from "./OrganizerShell.vue?vue&type=script&lang=js"

import "./OrganizerShell.vue?vue&type=style&index=0&id=dfd2259a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd2259a"]])

export default __exports__